// Contract defaults for the optional `action.proposed` fields
const aiAssistantProposalDefaults = {
    AUTO_CLOSE_MS: 3000,
    EXPIRES_IN_MS: 30000,
};

export default aiAssistantProposalDefaults;
